import { Observable, of } from 'rxjs'
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from '@angular/router'
import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { catchError, map, switchMapTo, take, tap } from 'rxjs/operators'
import { LoadSignaturePreferenceAction } from './preference.actions'
import { selectSignaturePrefLoaded } from './preference.selectors'

@Injectable()
export class SignaturePreferenceGuard {
  constructor(private store: Store<any>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(selectSignaturePrefLoaded),
      tap((isLoaded) => {
        if (!isLoaded) {
          this.store.dispatch(LoadSignaturePreferenceAction())
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate()
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
